import { HeaderInterface, NavigationListItemInterface } from '@qlevr/shared/interfaces';

export const isNavigationListItem = (item: HeaderInterface['navigation'][0]): item is NavigationListItemInterface => {
  return 'subMenu' in item;
};
